import { ShoppingSummary } from './ShoppingSummary';

export default ShoppingSummary;
